<template>
  <div class="cy-sanitary-equipment">
    <div v-html="$t('special_orders.description')"></div>

    <item-block v-for="(item, i) in extraOptions" :key="'choosable-item-' + i">
      <ExtraSelectableItem
        :item="item"
        :value="$store.state.preferences.selected_extras.includes(item.slug)"
        @input="onInput(item.slug, $event)"
      />
    </item-block>
  </div>
</template>

<script>
import ExtraSelectableItem from "../../ExtraSelectableItem";
export default {
  components: {
    ExtraSelectableItem,
  },
  computed: {
    extraOptions() {
      return this.$store.getters.apartment.available_extras;
    },
    selectedExtraSlugs() {
      return this.$store.state.preferences.selected_extras;
    },
  },
  data() {
    return {
      selected: {},
    };
  },
  methods: {
    onInput(slug, isSelected) {
      let selected = this._.cloneDeep(this.selectedExtraSlugs);

      if (isSelected) {
        if (!selected.includes(slug)) selected.push(slug);
      } else {
        selected = selected.filter((el) => el !== slug);
      }

      const updatables = {
        selected_extras: selected,
      };

      this.$store.dispatch("setPreference", updatables);
    },
  },
};
</script>
